import { Button } from 'components/Button';
import { Modal } from 'components/modal/Modal';
import React, { Fragment, useState } from 'react';
import { FormEmail } from 'components/form/FormEmail';
import './ModalIdentityVerification.scss';
/**
 * @component ModalIdentityVerification
 * @since 1.0.0
 * @hidden
 */
export function ModalIdentityVerification(props) {
    var _a, _b, _c, _d, _e;
    const { deal, hasIdentityVerification, hasTrackingShares, onClose } = props;
    const [identityVerified, setIdentityVerified] = useState(false);
    const [viewerEmail, setViewerEmail] = useState('');
    const email = ((_b = (_a = deal === null || deal === void 0 ? void 0 : deal.contact) === null || _a === void 0 ? void 0 : _a.primaryEmail) === null || _b === void 0 ? void 0 : _b.email) ||
        ((_e = (_d = (_c = deal === null || deal === void 0 ? void 0 : deal.client) === null || _c === void 0 ? void 0 : _c.primaryLocation) === null || _d === void 0 ? void 0 : _d.primaryEmail) === null || _e === void 0 ? void 0 : _e.email) ||
        '';
    const partiallyHiddenEmail = email.replace(/(.{2})(.*)(?=@)/, (_, a, b) => a + '*'.repeat(b.length));
    const footerActions = (React.createElement(Fragment, null,
        React.createElement(Button, { style: "outline", label: t('Privacy Policy'), onPress: () => {
                window.open('https://drive.google.com/file/d/1MRD4LDuKRvVkHz0NEOP-f5VQp4OIqTEz/view?usp=sharing', '_blank');
            } }),
        React.createElement(Button, { style: "primary", label: t('View Interactive Quote #') + (deal === null || deal === void 0 ? void 0 : deal.number), onPress: () => onClose(viewerEmail), disabled: !identityVerified })));
    return (React.createElement("div", { className: "modal-identity-verification" },
        React.createElement(Modal, { picto: "warning", title: t('Identity Verification Required'), showFooterAction: true, footerActions: footerActions, hideClose: true },
            React.createElement("div", { className: "modal-identity-verification-content" },
                React.createElement("div", { className: "modal-identity-verification-content__text" },
                    React.createElement("p", null, t('Please confirm your email address to view the interactive quote.')),
                    React.createElement(FormEmail, { label: t('Email'), onChange: (value) => {
                            var _a;
                            setViewerEmail(value);
                            if (hasIdentityVerification) {
                                if (value === email || value === ((_a = deal === null || deal === void 0 ? void 0 : deal.user) === null || _a === void 0 ? void 0 : _a.email)) {
                                    setIdentityVerified(true);
                                }
                                else {
                                    setIdentityVerified(false);
                                }
                            }
                            else {
                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                if (emailRegex.test(value)) {
                                    setIdentityVerified(true);
                                }
                                else {
                                    setIdentityVerified(false);
                                }
                            }
                        }, placeholder: hasIdentityVerification
                            ? partiallyHiddenEmail
                            : t('example@example.com') }))))));
}
